import React from "react";
import { Login } from "components/__subComponents/LoginPage";
import { Styles } from "./Styled";

const LoginPage = () => {
  return (<Styles>
    <Login />
  </Styles>)
}

export default LoginPage;
